import { LoginField } from "..//components/LoginField";
import { useEffect, useState } from "react";
import RedirectBTN from "../components/RedirectBTN";
import { VerifyPassword, validateEmail } from "../util/accountChecks";
import { LoginButton } from "../components/LoginButton";
import { UserLoginState } from "../util/userLoginState";
import { EditLoginField } from "../components/EditLoginField";
import useAccountManagementStore from "../../../stores/accountManagementStore";
import { useAccountManagementFunctions } from "../hooks/useAccountManagementFunctions";
import { useFormCooldown } from "../hooks/useFormCooldown";

type currentEdit = "" | "Email" | "Password";
export default function UpdateInformationView() {
    const [currentEdit, setCurrentEdit] = useState<currentEdit>();
    const userLoginState = UserLoginState();

    const { setLoginState, userData } = useAccountManagementStore(
        (state) => state,
    );
    const { updateEmail, updatePassword } = useAccountManagementFunctions();
    const emailCooldown = useFormCooldown(1);
    const passwordCooldown = useFormCooldown(1);

    useEffect(() => {
        if (userData?.email !== undefined) {
            userLoginState.setEmail(userData?.email);
        } else {
            userLoginState.setEmail("");
        }
    }, [userData]);

    async function submitEmailChange() {
        userLoginState.setEmailErrorMessage(undefined);

        if (currentEdit !== "Email") {
            setCurrentEdit("Email");
        } else {
            if (userLoginState.email === userData.email) {
                setCurrentEdit("");
                return;
            }

            if (!validateEmail(userLoginState.email)) {
                userLoginState.setEmailErrorMessage(
                    "Please enter a valid email address",
                );
                return;
            }

            if (!emailCooldown.canSubmit) return;

            try {
                const result = await updateEmail(userLoginState.email);

                if (!result) {
                    userLoginState.setEmailErrorMessage("An error occurred");
                    emailCooldown.startCooldown();
                } else {
                    setLoginState("checkEmail_UpdateEmail");
                }
            } catch (error) {
                userLoginState.setEmailErrorMessage("An error occurred");
                emailCooldown.startCooldown();
            }
        }
    }

    async function submitPasswordChange() {
        userLoginState.setPasswordErrorMessage(undefined);

        if (currentEdit !== "Password") {
            setCurrentEdit("Password");
        } else {
            userLoginState.setPasswordErrorMessage(undefined);
            userLoginState.setVerifyPasswordErrorMessage(undefined);

            const verifyPassword = VerifyPassword(userLoginState.password);
            if (verifyPassword !== null) {
                userLoginState.setPasswordErrorMessage(verifyPassword);
                return;
            }

            if (userLoginState.password !== userLoginState.confirmPassword) {
                userLoginState.setVerifyPasswordErrorMessage(
                    "Passwords do not match.",
                );
                return;
            }

            if (!passwordCooldown.canSubmit) return;

            try {
                const result = await updatePassword(userLoginState.password);

                if (result === "same_password") {
                    userLoginState.setPasswordErrorMessage(
                        "New password has not changed",
                    );
                    return;
                } else if (result === null) {
                    userLoginState.setVerifyPasswordErrorMessage(
                        "An Error Occurred",
                    );
                    passwordCooldown.startCooldown();
                } else {
                    setLoginState("checkEmail_ResetPassword");
                    setCurrentEdit("");
                }
            } catch (error) {
                userLoginState.setVerifyPasswordErrorMessage(
                    "An Error Occurred",
                );
                passwordCooldown.startCooldown();
            }
        }
    }

    // function deleteAccount() {
    //     setLoginState("deleteAccountConfirm");
    // }

    return (
        <div className="updateAccountForm flex flex-col p-9 pb-7 text-center text-white">
            <b className="mb-3 flex content-center justify-center text-2xl">
                Update Account
            </b>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitEmailChange();
                }}
            >
                <EditLoginField
                    fieldID="email"
                    fieldTitle="Email"
                    fieldType="email"
                    value={userLoginState.email}
                    onChange={(e) => {
                        userLoginState.setEmail(e.target.value);
                    }}
                    disabled={currentEdit !== "Email" || !emailCooldown.canSubmit}
                    clickedEditButton={() => {
                        submitEmailChange();
                    }}
                    invalidInput={
                        userLoginState.emailErrorMessage !== undefined
                    }
                    errorMessage={userLoginState.emailErrorMessage}
                />
            </form>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitPasswordChange();
                }}
            >
                <EditLoginField
                    fieldID="password"
                    fieldTitle="Password"
                    fieldType="password"
                    value={userLoginState.password}
                    onChange={(e) => {
                        userLoginState.setPassword(e.target.value);
                    }}
                    disabled={currentEdit !== "Password" || !passwordCooldown.canSubmit}
                    clickedEditButton={() => {
                        submitPasswordChange();
                    }}
                    invalidInput={
                        userLoginState.passwordErrorMessage !== undefined
                    }
                    errorMessage={userLoginState.passwordErrorMessage}
                />
                {currentEdit === "Password" && (
                    <LoginField
                        fieldID="confirmPassword"
                        fieldTitle="Confirm Password"
                        fieldType="password"
                        value={userLoginState.confirmPassword}
                        onChange={(e) => {
                            userLoginState.setConfirmPassword(e.target.value);
                        }}
                        invalidInput={
                            userLoginState.verifyPasswordErrorMessage !==
                            undefined
                        }
                        errorMessage={userLoginState.verifyPasswordErrorMessage}
                    />
                )}
            </form>
            <div className="mb-2 flex w-full space-x-2 self-center text-sm">
                <RedirectBTN
                    name="Cancel"
                    onClick={() => {
                        setLoginState("default");
                    }}
                />
            </div>
            {/* <LoginButton
                className="my-1 h-[36px] rounded text-sm"
                style={{
                    backgroundColor: "#ce1811",
                }}
                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    e.preventDefault();
                    deleteAccount();
                }}
            >
                Delete Account
            </LoginButton> */}
        </div>
    );
}
